import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { CurvaAbcVendaFilter, CurvaAbcVendaFilterService } from '../../filter';
import { CurvaAbcVenda } from '../../curva-abc-venda';
import { CurvaAbcVendaPerspectiva } from '../curva-abc-venda-perspectiva';

@Injectable({
    providedIn: 'root'
})
export class CurvaAbcVendaPerspectivaHttpService {
    resource = 'curvaabcvenda';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp,
                private curvaAbcVendaFilterService: CurvaAbcVendaFilterService) {
        this.pathApi = `${configServerService.getPathApiConsulta()}/${this.resource}`;
    }

    /** Realiza a consulta da curva abc de vendas */
    search(perspectiva: CurvaAbcVendaPerspectiva, filter: CurvaAbcVendaFilter, orderBy: number, orderByDir: string): Observable<CurvaAbcVenda> {
        const params = this.curvaAbcVendaFilterService.createHttpParams(perspectiva, filter, orderBy, orderByDir);
        return this.customHttp.get<CurvaAbcVenda>(this.pathApi, {params});
    }
}
